import React, {useCallback} from 'react';
import './PlayersListSideMenu.css'
import PlayersList from "../../PlayerList/PlayersList";
import {usePlayersListSideMenu} from "../../../contexts/PlayersListSideMenuContext";
import {SIDE_MENU_IDS, useSideMenuStack} from "../../../contexts/SideMenuStackContext";
import {useSideMenuEscape} from "../../../hooks/input/useSideMenuEscape";
import {REGISTRY_SINGLETON} from "../../../scenes/Registry";
import SpectatorsCount from "./SpectatorsCount";
import MissionTasksPanel from "../../Mission/MissionTasksPanel/MissionTasksPanel";
import HeaderDropdown, {HEADER_DROPDOWN_ANCHORS} from "../HeaderDropdown/HeaderDropdown";

// Список игроков выпадает вниз от строки игроков в шапке (HeaderPlayersRow;
// на телефоне — полоса под шапкой). Закрывают крестик, Esc, повторное
// нажатие на строку, а на телефоне — нажатие мимо. Перехват инициативы — в
// футере, правила — в меню матча
const PlayersListSideMenu = () => {
  const {isMenuOpen, closeMenu} = usePlayersListSideMenu();
  const {topSideMenuId} = useSideMenuStack();

  const handleCloseMenu = useCallback(() => {
    REGISTRY_SINGLETON.getSoundManager().playSideMenuClick();
    closeMenu();
  }, [closeMenu]);

  useSideMenuEscape(SIDE_MENU_IDS.PLAYERS_LIST, isMenuOpen, handleCloseMenu);

  return (
    <HeaderDropdown
      isOpen={isMenuOpen}
      onClose={handleCloseMenu}
      anchor={HEADER_DROPDOWN_ANCHORS.PLAYERS}
      isFocused={topSideMenuId === SIDE_MENU_IDS.PLAYERS_LIST}
      title={'Игроки'}
      // Сколько человек смотрит матч со стороны (см. SpectatorsCount)
      headerExtra={<SpectatorsCount/>}
    >
      <PlayersList/>

      {/* Задания сюжетной миссии — и на десктопе, и на мобильном именно
          здесь (в обучении поведение прежнее) */}
      <MissionTasksPanel/>
    </HeaderDropdown>
  );
};

export default PlayersListSideMenu;
